import TranslationProvider from './TranslationProvider';
import useTrans from './useTrans';

export { useTrans };
export default TranslationProvider;
